import { ChatbotMessages } from "@core/domain/models/chatbot-message.model";
import type { ChatbotRepository } from "@core/domain/repositories/chatbot.repository";
import { ToastManagerRepository } from "@core/domain/repositories/toast-manager.repository";
import { coreTypes } from "@core/root/core-types.di";
import { inject, injectable } from "inversify";

@injectable()
export class ChatbotMessagesGetAllUseCase {
    constructor(
        @inject(coreTypes.repositories.ChatbotRepository)
        private readonly chatbotRepository: ChatbotRepository,
    ) {}

    async execute(): Promise<ChatbotMessages> {
        const chatbotMessagesResult =
            await this.chatbotRepository.getChatbotMessages();

        if (chatbotMessagesResult.isErr()) {
            ToastManagerRepository.error(chatbotMessagesResult.error.message);
        }

        return chatbotMessagesResult.match(
            (chatbotMessages) => chatbotMessages,
            () => ChatbotMessages.empty(),
        );
    }
}
